/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = None

1 = LeadsListView

2 = LeadsActivityView

3 = LeadsActivityCalendarView

4 = BidsBuilder

5 = BudgetPOView

6 = BudgetSummaryView

7 = CalendarMonthView

8 = CalendarWeekView

10 = CalendarGanttView

11 = ScheduleBaselineView

12 = ScheduleWorkdayExceptionView

14 = Settlements

15 = MessagesListView

16 = MessagesCommentsView

17 = MessagesConversationsView

18 = ChangeOrdersListView

19 = ChangeOrdersProfitSummaryView

20 = SelectionsCategoryView

21 = SelectionsLocationView

22 = SelectionsListView

23 = WarrantySummaryView

24 = WarrantyDetailedView

25 = WarrantyAddedCostView

26 = UsersInternalView

27 = UsersSubsView

28 = ToDoSummaryView

29 = POPaymentsView

30 = CalendarDayView

31 = DailyLogView

32 = NotificationHistory

33 = JobsList

34 = CalendarPhaseView

35 = SelectionsAllowanceView

36 = ScheduleListView

37 = CalendarAgendaView

38 = TimeClockReportView

39 = OwnerPaymentsList

40 = IndividualSurveyList

41 = GroupedSurveyList

42 = SurveyQuestionsList

43 = TimeClockMapView

44 = LeadsMapView

47 = LeadsDetailActivityView

48 = ReceiptsList

49 = UsersContactsView

50 = SelectionCardView

51 = MerchantPayments

54 = AdminChurnReport

55 = LeadsActivityTemplate

56 = CreditMemos

57 = InvoicePayments

61 = LeadProposals

62 = SelectionConditionView

63 = PurchaseOrderList

64 = RFIsList

68 = RiskInsurance

69 = OnlinePaymentReport

73 = LeadProposalTemplate

74 = CalendarView

75 = OutgoingPayments

76 = MediaFolderDetails

77 = DocumentFolderDetails

78 = PhotoFolderDetails

79 = VideoFolderDetails

80 = AdminBuilderMetrics

82 = CalendarPredecessorView

83 = InternalUserDetailsJobsList

84 = SubDetailsJobsList

85 = CalendarShiftHistory

86 = SelectionFavorites

87 = BudgetCategory

88 = ContactDirectory

89 = ContactDropdown

90 = Dropdown

91 = CostCodeItems

92 = JobPicker

93 = TemplateJobPicker

95 = TemplatesList

96 = PhotoAttachedAlbumDetails

97 = QuestionReport

99 = CostGroups

101 = OrderForms

104 = LeadCountPerSalesperson

106 = LeadActivitiesPerSalesperson

108 = LeadStatusBySource

109 = DailyLogCountPerUser

110 = TotalHoursWorkedByUser

112 = ProjectCompletionPerJob

115 = YourPayments

120 = BaselineVsActualDuration

121 = TotalHoursWorkedByJob

133 = ChangeOrderProfitReport

134 = EstimateWorksheet

135 = ActivityFeed

136 = WarrantyServices

139 = TaxRates

140 = TaxGroups

141 = SubscriptionSignUpCodes

142 = SpecificationsList

143 = OnlinePaymentAccountStatus

144 = Deposits

145 = JobCostingBudget

146 = GroupedOnlinePayments

147 = Notifications

148 = Submittals


 */
export type ResultFilterType =
  (typeof ResultFilterType)[keyof typeof ResultFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResultFilterType = {
  None: 0,
  LeadsListView: 1,
  LeadsActivityView: 2,
  LeadsActivityCalendarView: 3,
  BidsBuilder: 4,
  BudgetPOView: 5,
  BudgetSummaryView: 6,
  CalendarMonthView: 7,
  CalendarWeekView: 8,
  CalendarGanttView: 10,
  ScheduleBaselineView: 11,
  ScheduleWorkdayExceptionView: 12,
  Settlements: 14,
  MessagesListView: 15,
  MessagesCommentsView: 16,
  MessagesConversationsView: 17,
  ChangeOrdersListView: 18,
  ChangeOrdersProfitSummaryView: 19,
  SelectionsCategoryView: 20,
  SelectionsLocationView: 21,
  SelectionsListView: 22,
  WarrantySummaryView: 23,
  WarrantyDetailedView: 24,
  WarrantyAddedCostView: 25,
  UsersInternalView: 26,
  UsersSubsView: 27,
  ToDoSummaryView: 28,
  POPaymentsView: 29,
  CalendarDayView: 30,
  DailyLogView: 31,
  NotificationHistory: 32,
  JobsList: 33,
  CalendarPhaseView: 34,
  SelectionsAllowanceView: 35,
  ScheduleListView: 36,
  CalendarAgendaView: 37,
  TimeClockReportView: 38,
  OwnerPaymentsList: 39,
  IndividualSurveyList: 40,
  GroupedSurveyList: 41,
  SurveyQuestionsList: 42,
  TimeClockMapView: 43,
  LeadsMapView: 44,
  LeadsDetailActivityView: 47,
  ReceiptsList: 48,
  UsersContactsView: 49,
  SelectionCardView: 50,
  MerchantPayments: 51,
  AdminChurnReport: 54,
  LeadsActivityTemplate: 55,
  CreditMemos: 56,
  InvoicePayments: 57,
  LeadProposals: 61,
  SelectionConditionView: 62,
  PurchaseOrderList: 63,
  RFIsList: 64,
  RiskInsurance: 68,
  OnlinePaymentReport: 69,
  LeadProposalTemplate: 73,
  CalendarView: 74,
  OutgoingPayments: 75,
  MediaFolderDetails: 76,
  DocumentFolderDetails: 77,
  PhotoFolderDetails: 78,
  VideoFolderDetails: 79,
  AdminBuilderMetrics: 80,
  CalendarPredecessorView: 82,
  InternalUserDetailsJobsList: 83,
  SubDetailsJobsList: 84,
  CalendarShiftHistory: 85,
  SelectionFavorites: 86,
  BudgetCategory: 87,
  ContactDirectory: 88,
  ContactDropdown: 89,
  Dropdown: 90,
  CostCodeItems: 91,
  JobPicker: 92,
  TemplateJobPicker: 93,
  TemplatesList: 95,
  PhotoAttachedAlbumDetails: 96,
  QuestionReport: 97,
  CostGroups: 99,
  OrderForms: 101,
  LeadCountPerSalesperson: 104,
  LeadActivitiesPerSalesperson: 106,
  LeadStatusBySource: 108,
  DailyLogCountPerUser: 109,
  TotalHoursWorkedByUser: 110,
  ProjectCompletionPerJob: 112,
  YourPayments: 115,
  BaselineVsActualDuration: 120,
  TotalHoursWorkedByJob: 121,
  ChangeOrderProfitReport: 133,
  EstimateWorksheet: 134,
  ActivityFeed: 135,
  WarrantyServices: 136,
  TaxRates: 139,
  TaxGroups: 140,
  SubscriptionSignUpCodes: 141,
  SpecificationsList: 142,
  OnlinePaymentAccountStatus: 143,
  Deposits: 144,
  JobCostingBudget: 145,
  GroupedOnlinePayments: 146,
  Notifications: 147,
  Submittals: 148,
} as const;
